export default __webpack_public_path__ + "static/media/monstera.ec0819da.jpg";